// extracted by extract-css-chunks-webpack-plugin
module.exports = {"main_nav":"main_nav-3Y7UHC5a","user":"user-2mgrMszO","box":"box-d2Ko9WDB","ad":"ad-2hQhBZjj","search":"search-DrnvCNff","logo":"logo-XIfDGMn2"};